import React, { useState } from "react";
import AquariumMarker from "../../images/marker_both.png";
import AssociateMarker from "../../images/marker_associate.png";
import CorporateMarker from "../../images/marker_coporate.png";
import Button from "../button";
import {
  GoogleMap,
  Marker,
  InfoWindow,
  useJsApiLoader,
} from "@react-google-maps/api";
import { Link } from "gatsby";

const MembersMap = ({ data }) => {
  const [selectedFilter, setSelectedFilter] = useState("");
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [selectedMarkerTitle, setSelectedMarkerTitle] = useState("");
  const [selectedMarkerData, setSelectedMarkerData] = useState({});
  const [mapCenter] = useState({ lat: 52.7844, lng: 6.89313 });

  const allPositions = data.members?.map((pos) => ({
    lat: parseFloat(pos.Lattitude),
    lng: parseFloat(pos.Longitude),
    category: pos.MemberCategory,
    data: pos,
  }));

  const handleRadioChange = (filterName) => {
    setSelectedFilter(filterName);
    setSelectedMarker(null); // Close marker pop-up on filter change
  };

  const filteredPositions = selectedFilter
    ? allPositions?.filter((pos) => pos.category === selectedFilter)
    : allPositions;

  const handleMarkerClick = (position, title, data) => {
    const formattedUrl = data.WebsiteUrl.startsWith("http")
      ? data.WebsiteUrl
      : `https://${data.WebsiteUrl}`;

    setSelectedMarker(position);
    setSelectedMarkerTitle(title);
    setSelectedMarkerData({ ...data, WebsiteUrl: formattedUrl });
  };

  const handleMapClick = (event) => {
    if (
      event.domEvent?.target &&
      !event.domEvent.target.closest(".gm-style-iw")
    ) {
      setSelectedMarker(null);
    }
  };

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.GATSBY_GOOGLE_MAP_API,
  });

  return (
    <div className="my-18 relative mx-auto max-w-screen-xl xxl:max-w-screen-3xl">
      <div className="max-w-screen-xl xxl:max-w-screen-3xl bg-lightblack py-10 text-center">
        <div className="lg:px-5 px-10 lg:flex justify-between items-start gap-8">
          <h3 className="text-white text-left text-2xl font-bold font-sans lg:mb-0 mb-6">
            {data.Title}
            <div className="mt-7 text-left">
              {data.Button?.ShowButton && <Button data={data.Button} />}
            </div>
          </h3>
          <div>
            <ul className="flex lg:flex-row flex-col text-white gap-4 lg:mt-0 mt-6 lg:pt-2">
              {["Associate Member", "Corporate Member", "Zoo/Aquarium"].map(
                (category) => (
                  <li key={category} className="flex items-center gap-2">
                    <input
                      type="radio"
                      name="memberCategory"
                      id={category}
                      checked={selectedFilter === category}
                      onChange={() => handleRadioChange(category)}
                    />
                    <label className="text-base font-sans" htmlFor={category}>
                      {category}
                    </label>
                  </li>
                )
              )}
            </ul>
          </div>
        </div>
      </div>
      <div className="max-w-screen-2xl mx-auto xxl:max-w-screen-3xl">
        {isLoaded ? (
          <GoogleMap
            mapContainerStyle={{ width: "100%", height: "436px" }}
            center={mapCenter}
            zoom={5}
            onClick={handleMapClick}
          >
            {filteredPositions?.map((position, index) => (
              <Marker
                key={index}
                position={position}
                icon={{
                  url:
                    position.category === "Associate Member"
                      ? AssociateMarker
                      : position.category === "Corporate Member"
                      ? CorporateMarker
                      : AquariumMarker,
                }}
                onClick={(e) => {
                  e.domEvent.stopPropagation();
                  handleMarkerClick(
                    position,
                    position.data.OrganisationName,
                    position.data
                  );
                }}
              />
            ))}
            {selectedMarker && (
              <InfoWindow
                position={selectedMarker}
                onCloseClick={() => setSelectedMarker(null)}
              >
                <div className="flex justify-between p-2 gap-3">
                  <div className="flex flex-col gap-2">
                    <h2 className="font-bold text-sm">{selectedMarkerTitle}</h2>
                    <a
                      href={selectedMarkerData.WebsiteUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="rounded-lg py-2 font-display text-base no-underline text-orange"
                    >
                      {selectedMarkerData.WebsiteUrl}
                    </a>
                    <p className="font-medium">{selectedMarkerData.Country}</p>
                    <p className="text-orange font-medium">
                      {selectedMarkerData.Membership}
                    </p>
                  </div>
                  {selectedMarkerData.MemberLogo?.url && (
                    <img
                      src={`${process.env.GATSBY_STRAPI_API_URL}${selectedMarkerData.MemberLogo.url}`}
                      alt="Logo"
                      className="border border-[#d1d5db]"
                    />
                  )}
                </div>
              </InfoWindow>
            )}
          </GoogleMap>
        ) : null}
      </div>
    </div>
  );
};

export default MembersMap;
